import { styled } from '@mui/material';

export const CardContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  justifyContent: 'center',
  padding: theme.spacing(14, 0, 7, 0)
}));
